module.exports = __webpack_public_path__ + "static/img/bug.0c28147.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bug.svg
// module id = PVfb
// module chunks = 11